module.exports = __webpack_public_path__ + "img/HealthManagement.c57286dc.png";